import type { HelpWidgetSession } from '@wix/ambassador-helpwidget-v1-session/types';

import { WidgetSessionUpdatePayloadDeprecated } from '../../../server/service/helpWidgetSession';
import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { httpClient } from '../httpClient';

const {
  clientTopology: { helpCenterSessionUrl },
} = renderModel.get();

type UpdateWidgetSessionErrorResponse = {
  error?: {
    message: string;
  };
};

type UpdateWidgetSessionResponse = UpdateWidgetSessionErrorResponse & {
  helpWidgetSession: HelpWidgetSession;
};

export async function updateHelpWidgetSession(
  payload: WidgetSessionUpdatePayloadDeprecated,
): Promise<HelpWidgetSession | null> {
  try {
    const { data } = await httpClient
      .getInstance()
      .put<UpdateWidgetSessionResponse>(helpCenterSessionUrl, payload);

    if (data.error) {
      throw new Error(data.error.message);
    }

    return data.helpWidgetSession;
  } catch (error) {
    const message = 'Failed to update help widget session';
    logger.log({ error, message, callParams: payload });
    console.error(error);
    return null;
  }
}
